export default "__VITE_ASSET__0ee57c30__"